import { Button, Props as ButtonProps } from "common/buttons";
import React from "react";

export const SubmitButton: React.FC<
  React.PropsWithChildren<Omit<ButtonProps, "type">>
> = (props) => <Button {...props} type="submit" />;
